import React from 'react';
import { CrudTabs } from 'Modules/Crud';
import { SelectInput } from 'Views/Components/New/SelectInput';

export interface SectionTab {
	id: string;
	label: string;
}

interface SectionTabsProps {
	tabs: SectionTab[];
	activeTab: string;
	onChange: (tabId: string) => void;
	isMobile: boolean;
	/** When set, only these tab ids are offered (e.g. the tabs in an active edit session). */
	lockedToIds?: string[];
	/** Extra classes for the desktop tab row. Defaults to the card-attached style. */
	tabsClassName?: string;
}

/**
 * Responsive section navigation for the account pages: the Crud tab row on desktop, a
 * full-width section picker on mobile — a long tab set would otherwise scroll off a phone.
 */
export default function SectionTabs({
	tabs,
	activeTab,
	onChange,
	isMobile,
	lockedToIds,
	tabsClassName = 'mt-4 rounded-t-xl border border-gray-200',
}: SectionTabsProps) {
	const availableTabs = lockedToIds ? tabs.filter(t => lockedToIds.includes(t.id)) : tabs;

	if (isMobile) {
		return (
			<div className="mt-4" data-test-id="user-detail-section-select">
				<SelectInput
					label=""
					aria-label="Section"
					options={availableTabs.map(t => ({ value: t.id, label: t.label })) as any}
					value={{
						value: activeTab,
						label: tabs.find(t => t.id === activeTab)?.label ?? tabs[0]?.label,
					}}
					onChange={(option: any) => onChange(option?.value ?? tabs[0]?.id)}
					isSearchable={false}
				/>
			</div>
		);
	}

	return <CrudTabs className={tabsClassName} tabs={availableTabs} activeTab={activeTab} onChange={onChange} />;
}
